module.exports = __webpack_public_path__ + "img/Fernsehen_Black.be622f19.png";